import factory from "./factory";

const organizationRequest = factory({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}/organization/`,
});

export default organizationRequest;
